<template>
  <div class="aaaaa">
  <div class="children-box bbbbb " v-loading="uploadLoading" >
    <div class="nav">
      <h3>商品信息</h3>
      <el-button style="font-size: 16px; width: 100px" plain @click="goBack">返回</el-button>
    </div>
    <div class="procedure">
      <div class="firstStep" v-show="showFirst">
        <div class="step">
          <div class="item-num active-color size">1</div>
          <span class="item-text">编辑基本信息</span>
          <!-- <div class="line"></div>
          <div class="item-num unactive-color size">2</div>
          <span class="item-text">编辑销售信息</span> -->
        </div>
        <div class="title">
          <h3>基本信息</h3>
        </div>

        <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="110px">
          <el-form-item label="商品名称" prop="productName">
            <!--            <template slot="label">-->
            <!--              <span><span style="color: red">*</span>商品名称</span>-->
            <!--            </template>-->
            <el-input ref="testaid" style="width: 300px" v-model="formData.productName" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="商品简称" prop="shortName">
            <template slot="label">
              <span><span style="color: red">*</span>商品简称</span>
            </template>
            <el-input style="width: 150px" v-model="formData.shortName" placeholder="请输入（4字以内）"></el-input>
          </el-form-item>

          <el-form-item label="卖点" prop="sellPoint">
            <template slot="label">
              <span>卖点描述</span>
              <input style="width: 0;height: 0;opacity: 0;padding: 0;border: none;" ref="sellPointaid"/>
            </template>
            <div class="label_list">
              <div class="label_item" v-for="(item, index) in formData.sellPoint" :key="index">
                <el-input :value="showsp(index)" @input="(e) => updateSp(e, index)" placeholder="请输入"></el-input>
                <span class="label_item_opt" @click="delsellpoint(index)" title="删除">
                  <i class="el-icon-circle-close"></i>
                </span>
              </div>
              <el-button type="text" class="label_btn" @click="addsellpoint">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px"></i>
                添加卖点
              </el-button>
            </div>
          </el-form-item>
          <el-form-item label="标签" prop="label">
            <template slot="label">
              <span>标签</span>
              <input style="width: 0;height: 0;opacity: 0;padding: 0;border: none;" ref="labelaid"/>
            </template>
            <div class="label_list">
              <div class="label_item" v-for="(item, index) in formData.label" :key="index">
                <!-- <div
                  class=""
                  v-if="['七天无理由', '运费险', '配送到家'].includes(item)"
                ></div> -->
                <el-input :value="showLabel(index)" @input="(e) => updateLabel(e, index)"
                          placeholder="请输入"></el-input>
                <span class="label_item_opt" @click="dellabel(index)" title="删除">
                  <i class="el-icon-circle-close"></i>
                </span>
              </div>
              <el-button type="text" class="label_btn" @click="addLabel">
                <i class="el-icon-circle-plus-outline" style="font-size: 20px"></i>添加标签
              </el-button>
            </div>
          </el-form-item>

          <el-form-item label="商品一级分类">
            <template slot="label">
              <span><span style="color: red">*</span>商品一级分类</span>
            </template>
            <el-input readonly v-model="formData.categoryFirstName" placeholder="请输入"></el-input>
            <el-button @click="showClassifyDialog(1)" style="margin-left: 10px" type="primary">选择分类</el-button>
          </el-form-item>
          <el-form-item label="商品二级分类" v-if="formData.categoryFirstName">
            <template slot="label">
              <span><span style="color: red">*</span>商品二级分类</span>
            </template>
            <el-input readonly v-model="formData.categorySecondName" placeholder="请输入"></el-input>
            <el-button @click="showClassifyDialog(2)" style="margin-left: 10px" type="primary">选择分类</el-button>
          </el-form-item>

<!--          <el-form-item label="供应商">-->
<!--            <template slot="label">-->
<!--              <span><span style="color: red">*</span>供应商</span>-->
<!--            </template>-->
<!--            <el-input readonly v-model="formData.supplierName" placeholder="请输入"></el-input>-->
<!--            <el-button @click="showSupplierDialog" style="margin-left: 10px" type="primary">选择供应商</el-button>-->
<!--            <el-button @click="resetSupplier" style="margin-left: 10px">重置</el-button>-->
<!--          </el-form-item>-->
          <el-form-item label="商品来源">
            <template slot="label">
              <span>商品来源</span>
            </template>
            <el-input style="width: 300px;" v-model="formData.source" placeholder="请输入商品来源"></el-input>
          </el-form-item>

          <el-form-item label="商品原价" prop="originalPrice">
            <template slot="label">
              <span><span style="color: red">*</span>商品原价</span>
            </template>
            <el-input v-model="formData.originalPrice" placeholder="请输入" style="width: 100px" type="number" :min="0"
            />
          </el-form-item>

          <el-form-item label="属性">
            <template slot="label">
              <span><span style="color: red">*</span>商品属性</span>
            </template>
            <button type="button" @click="addItem">添加属性</button>

            <el-table class="tableSku" ref="table" :data="formData.productSkuList" border
                      style="width: 90%; margin-bottom: 30px">
              <el-table-column :render-header="addRedStar" prop="date" label="规格图片" width="180" align="center">
                <template slot-scope="scope">
                  <el-upload class="avatar-uploader" :action="$uploadURL" :on-progress="()=>{uploadLoading = true}" :show-file-list="false" :on-success="function (res, file, fileList) {
                    return handleUploadSkuImg(file, scope.$index);
                  }
                    ">
                    <img v-if="scope.row.skuImg" :src="scope.row.skuImg" class="avatarSmall"/>
                    <i v-else class="el-icon-upload small-uploader-icon"></i>
                  </el-upload>
                </template>
              </el-table-column>
              <el-table-column prop="skuName" style="position: relative" :render-header="addRedStar" label="规格名称"
                               width="180" align="center">
                <template slot-scope="scope">
                  <!--                  <el-input v-model="scope.row.skuName" placeholder="请输入" style="width: 150px" />-->

                  <el-form-item :prop="'productSkuList.' + scope.$index + '.skuName'" :rules="rules.skuName">
                    <el-input
                      v-model="scope.row.skuName"
                      placeholder="请输入">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="netWeight" :render-header="addRedStar" label="净重" align="center" width="150">
                <template slot-scope="scope">
                  <!--                  <el-input v-model="scope.row.netWeight" placeholder="请输入" style="width: 100px" type="number" :min="0"-->
                  <!--                    @input="handleInput($event, scope.$index, 1)" />-->

                  <el-form-item :prop="'productSkuList.' + scope.$index + '.netWeight'" :rules="rules.netWeight">
                    <el-input
                      v-model="scope.row.netWeight"
                      type="number" :min="0"
                      @input="handleInput($event, scope.$index, 1)"
                      placeholder="请输入">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <!--
               `volume` decimal(10,2) DEFAULT '0.00' COMMENT '体积',
  `size` varchar(255) DEFAULT NULL COMMENT '尺寸',
  `stock` decimal(10,2) DEFAULT '0.00' COMMENT '库存',
  `supplyPrice` decimal(10,2) DEFAULT '0.00' COMMENT '供货价',
  `originalPrice` decimal(10,2) DEFAULT '0.00' COMMENT '原价(划线价)',
  `sellPrice` decimal(10,2) DEFAULT '0.00' COMMENT '售卖价(零售价)',
              -->

              <el-table-column prop="originalPrice" :render-header="addRedStar" label="原价" align="center" width="150">
                <template slot-scope="scope">
                  <!--                  <el-input v-model="scope.row.originalPrice" placeholder="请输入" style="width: 100px" type="number"-->
                  <!--                    :min="0" @input="handleInput($event, scope.$index, 7)" />-->
                  <el-form-item :prop="'productSkuList.' + scope.$index + '.originalPrice'"
                                :rules="rules.originalPrice">
                    <el-input
                      v-model="scope.row.originalPrice"
                      placeholder="请输入">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="sellPrice" :render-header="addRedStar" label="售卖价" align="center" width="150">
                <template slot-scope="scope">
                  <!--                  <el-input v-model="scope.row.sellPrice" placeholder="请输入" style="width: 100px" type="number" :min="0"-->
                  <!--                    @input="handleInput($event, scope.$index, 8)" />-->
                  <el-form-item :prop="'productSkuList.' + scope.$index + '.sellPrice'" :rules="rules.sellPrice">
                    <el-input
                      v-model="scope.row.sellPrice"
                      placeholder="请输入">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="unit" label="单位" :render-header="addRedStar" align="center" width="120">
                <template slot-scope="scope">
                  <el-form-item :prop="'productSkuList.' + scope.$index + '.unit'" :rules="rules.unit">
                    <el-select v-model="scope.row.unit" placeholder="请选择">
                      <el-option label="g" value="g"></el-option>
                      <el-option label="kg" value="kg"></el-option>
                      <el-option label="ton" value="ton"></el-option>
                    </el-select>
                  </el-form-item>
                  <!--                  <div style="width: 100px">-->
                  <!--                    <el-select v-model="scope.row.unit" placeholder="请选择">-->
                  <!--                      <el-option label="g" value="g"> </el-option>-->
                  <!--                      <el-option label="kg" value="kg"> </el-option>-->
                  <!--                      <el-option label="ton" value="ton"> </el-option>-->
                  <!--                    </el-select>-->
                  <!--                  </div>-->
                </template>
              </el-table-column>

              <el-table-column prop="stock" :render-header="addRedStar" label="库存" width="180" align="center">
                <template slot-scope="scope">
                  <!--                  <el-input v-model="scope.row.stock" placeholder="请输入" style="width: 100px" type="number" :min="0"-->
                  <!--                    @input="handleInput($event, scope.$index, 2)" />-->

                  <el-form-item :prop="'productSkuList.' + scope.$index + '.stock'" :rules="rules.stock">
                    <el-input
                      v-model="scope.row.stock"
                      placeholder="请输入">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column prop="volume" label="体积" align="center" width="150">
                <template slot-scope="scope">
                  <!--                  <el-input v-model="scope.row.volume" placeholder="请输入" style="width: 100px" type="number" :min="0"-->
                  <!--                    @input="handleInput($event, scope.$index, 4)" />-->
                  <el-form-item>
                    <el-input
                      v-model="scope.row.volume"
                      type="number" :min="0"
                      @input="handleInput($event, scope.$index, 4)"
                      placeholder="请输入">
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="size" label="尺寸" align="center" width="150">
                <template slot-scope="scope">
                  <!--                  <el-input @input="handleInput($event, scope.$index, 5)" v-model="scope.row.size" placeholder="请输入"-->
                  <!--                    style="width: 100px" type="number" />-->


                  <el-form-item>
                    <el-input
                      v-model="scope.row.size"
                      type="number" :min="0"
                      @input="handleInput($event, scope.$index, 5)"
                      placeholder="请输入">
                    </el-input>
                  </el-form-item>

                </template>


              </el-table-column>
              <el-table-column prop="supplyPrice" label="供货价" align="center" width="150">
                <template slot-scope="scope">
                  <el-form-item>
                    <el-input
                      v-model="scope.row.supplyPrice"
                      type="number" :min="0"
                      @input="handleInput($event, scope.$index, 6)"
                      placeholder="请输入">
                    </el-input>
                  </el-form-item>

                  <!--                  <el-input v-model="scope.row.supplyPrice" placeholder="请输入" style="width: 100px" type="number"-->
                  <!--                    :min="0" @input="handleInput($event, scope.$index, 6)" />-->
                </template>
              </el-table-column>

              <el-table-column fixed="right" label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button type="text" @click="removeItem(scope.$index)" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <el-form-item label="商品封面图" prop="listImg">
            <template slot="label">
              <span><span style="color: red">*</span>商品封面图</span>
            </template>
            <el-upload list-type="picture-card" class="avatar-uploader" :action="$uploadURL"
                       :before-upload="beforeAvatarUpload" :on-progress="()=>{uploadLoading = true}" :show-file-list="false"
                       :on-success="handleUploadListImgSuccess"
                       :on-remove="handleUploadListImgRemove">
              <div v-if="formData.listImg" class="img-option" style="width: 100%;height: 100%;">
                <el-image ref="prevImg" style="width: 146px; height: 146px;" fit="cover"
                          :src="formData.listImg"></el-image>
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview"
                        @click.stop="handlePictureCardPreview(formData.listImg, true)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-uli-delete" @click.stop="handleRemove('', {}, true, 'listImg')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__tip" slot="tip">图片建议尺寸(1 × 1)</div>
            </el-upload>
          </el-form-item>

          <el-form-item label="商品轮播图" prop="bannerList">
            <template slot="label">
              <span><span style="color: red">*</span>商品轮播图</span>
            </template>
            <el-upload class="avatar-uploader" multiple :before-upload="beforeAvatarUpload" :action="$uploadURL"
                       :on-progress="()=>{uploadLoading = true}"    :show-file-list="false" :on-success="handBannerSuccess">
              <div class="imglist_c">
                <div v-if="bannerList.length > 0" class="flex img-option"
                     style="width: auto;min-height: 146px;flex-wrap: wrap;" @click.stop>
                  <div class="img-option_item" style="" v-for="(oitem, index) in bannerList" :key="index">
                    <el-image ref="prevImg" class="img-img" :src="oitem.url" fit="cover"></el-image>
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview"
                            @click.stop="handlePictureCardPreview(oitem.url, true)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span class="el-uli-delete" @click.stop="handleBannerRemove(oitem, index)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="img-option" style="width: 146px;height: 146px;">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </div>

              <div class="el-upload__tip" slot="tip">图片建议尺寸(800px*800px,不建议超过500kb)</div>
            </el-upload>
          </el-form-item>

          <el-form-item label="商品详情图" prop="bigImgList">
            <template slot="label">
              <span><span style="color: red">*</span>商品详情图</span>
            </template>
            <el-upload class="avatar-uploader" :on-success="handBigImgSuccess" multiple
                       :before-upload="beforeAvatarUpload" :file-list="fileList" :on-progress="()=>{uploadLoading = true}"   :action="$uploadURL"
                       :show-file-list="false">
              <div class="imglist_c">
                <div v-if="bigImgList.length > 0" class="flex img-option"
                     style="width: auto;min-height: 146px;flex-wrap: wrap;" @click.stop>
                  <draggable tag="div" class="cardDrag-list-wrap comp-list" v-model="bigImgList" :group="groupRight"
                             animation="50" delay="10" :sort="true" @update="onUpdate">
                    <div class="img-option_item" style="" v-for="(oitem, index) in bigImgList" :key="index">
                      <el-image ref="prevImg" class="img-img" :src="oitem.url" fit="cover"></el-image>
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview"
                              @click.stop="handlePictureCardPreview(oitem.url, true)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span class="el-uli-delete" @click.stop="handleBigImgRemove(oitem, index)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </draggable>
                </div>
                <div class="img-option" style="width: 146px;height: 146px;">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </div>

              <div class="el-upload__tip" slot="tip">图片建议尺寸(800px*800px,不建议超过500kb)</div>
            </el-upload>
          </el-form-item>

          <el-form-item label="检测报告">
            <template slot="label">
              <span>检测报告</span>
            </template>
            <el-upload list-type="picture-card" class="avatar-uploader" :action="$uploadURL"
                       :before-upload="beforeAvatarUpload" :show-file-list="false"
                       :on-progress="()=>{uploadLoading = true}"
                       :on-success="handleUploadReportImgSuccess"
                       :on-remove="handleUploadReportImgRemove">
              <div v-if="formData.reportImg" class="img-option" style="width: 100%;height: 100%;">
                <el-image ref="prevImg" style="width: 146px; height: 146px" :src="formData.reportImg"
                          fit="cover"></el-image>
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview"
                        @click.stop="handlePictureCardPreview(formData.reportImg, true)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span class="el-uli-delete" @click.stop="handleRemove('', {}, true, 'reportImg')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!-- <el-form-item label="商品详情" prop="detail">
            <template slot="label">
              <span>商品详情</span>
            </template>
            <QuillEditor
              class="rqe-editer"
              @contentChange="contentChange"
              :propsContent="formData.detail"
            ></QuillEditor>
          </el-form-item> -->

          <div class="title" v-if="deliveryShow">
            <h3>物流配置</h3>
          </div>

          <div v-if="deliveryShow">
            <span><span style="color: red">*</span>配送方式</span>
<!--            <el-checkbox v-model="isTeamDelivery" style="margin-left: 50px">团长配送</el-checkbox>-->
            <el-checkbox style="margin-left: 50px" v-model="isExpressDelivery">快递配送</el-checkbox>
<!--            <el-checkbox v-model="isVipDelivery">专享配送</el-checkbox>-->
<!--            <el-checkbox v-model="isSelfPickup">门店自提</el-checkbox>-->
          </div>
        </el-form>

        <div class="btn-box">
          <!-- <div class="next-btn" @click="nextStep">下一步</div> -->
          <div class="next-btn" @click="publish" v-loading="clickPrevent">
            上架
          </div>
        </div>
      </div>

    </div>

    <!-- 选择商品分类弹窗 -->
    <el-dialog title="选择分类" center :visible.sync="classifyDialog" width="70%">
      <div class="select-box">
        <!-- 弹窗搜索栏部分 -->
        <div>
          <el-row :gutter="10">
            <el-col :span="7">
              <div class="item-col">
                <span class="label">分类名称</span>
                <div>
                  <el-input v-model="classifySearch.condition.categoryName" style="width: 100%"
                            placeholder="请输入"></el-input>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="7">
              <div class="item-col">
                <span class="label">分类级别</span>
                <div>
                  <el-select v-model="classifySearch.condition.level" placeholder="请选择" style="width: 100%;">
                    <el-option label="一级分类" value="1">
                    </el-option>
                    <el-option label="二级分类" value="2">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-col> -->
            <el-col :span="5">
              <el-button type="primary" icon="el-icon-search" @click="searchClassify">查询</el-button>
              <el-button type="info" icon="el-icon-refresh" @click="restClassify">重置</el-button>
            </el-col>
          </el-row>
        </div>
        <!-- 弹窗数据展示部分 -->
        <div style="height: 350px; overflow-y: auto">
          <el-table :data="classifyData.classifyList" height="100%" style="width: 100%" border>
            <el-table-column prop="categoryName" label="分类名称" align="center">
            </el-table-column>
            <el-table-column prop="level" label="分类级别" align="center">
            </el-table-column>
            <el-table-column prop="logo" label="分类图片" align="center">
              <template slot-scope="{ row }">
                <img style="width: 50px; height: 50px" :src="row.logo" alt=""/>
              </template>
            </el-table-column>
            <el-table-column label="" width="100" align="center">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="selectClassify(row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex; justify-content: flex-end">
          <el-pagination background layout="prev, pager, next" :total="classifyData.count"
                         @current-change="handleCurrentChangeClassify">
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="classifyDialog = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 选择供应商弹窗 -->
    <el-dialog title="选择供应商" center :visible.sync="supplierDialog" width="70%">
      <div class="select-box">
        <!-- 弹窗搜索栏部分 -->
        <div>
          <el-row :gutter="10">
            <el-col :span="7">
              <div class="item-col">
                <span class="label">供应商名称</span>
                <div>
                  <el-input v-model="supplierSearch.condition.supplierName" style="width: 100%"
                            placeholder="请输入"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="item-col">
                <span class="label">法人姓名</span>
                <div>
                  <el-input v-model="supplierSearch.condition.name" style="width: 100%" placeholder="请输入"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="item-col">
                <span class="label">联系电话</span>
                <div>
                  <el-input v-model="supplierSearch.condition.linkPhone" style="width: 100%"
                            placeholder="请输入"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" icon="el-icon-search" @click="searchSupplier">查询</el-button>
              <el-button type="info" icon="el-icon-refresh" @click="restSupplier">重置</el-button>
            </el-col>
          </el-row>
        </div>
        <!-- 弹窗数据展示部分 -->
        <div style="height: 350px; overflow-y: auto">
          <el-table :data="supplierData.supplierList" height="100%" style="width: 100%" border>
            <el-table-column prop="supplierName" label="供应商名称" align="center">
            </el-table-column>
            <el-table-column prop="name" label="法人姓名" align="center">
            </el-table-column>
            <el-table-column prop="linkPhone" label="联系电话" align="center">
            </el-table-column>
            <el-table-column label="" width="100" align="center">
              <template slot-scope="{ row }">
                <el-button type="text" size="small" @click="selectSupplier(row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex; justify-content: flex-end">
          <el-pagination background layout="prev, pager, next" :total="supplierData.count"
                         @current-change="handleCurrentChangeSupplier">
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="supplierDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="preimgList"/>
  </div>
  </div>
</template>

<script>
// import { quillEditor } from "vue-quill-editor";
import {splitByComma} from '../../components/utils/img'
// import QuillEditor from "@/components/quillEditor.vue";
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
    // QuillEditor,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },

  data() {

    var PriceValidator = (rule, value, callback) => {
      console.log(value, 257)
      if (!value) {
        return callback(new Error('价格不能为空'))
      }
      // 使用正则表达式验证正数（包括最多两位小数）
      const regex = /^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/  // 支持整数和最多两位小数

      if (!regex.test(value) || parseFloat(value) <= 0) {
        return callback(new Error('请输入有效的价格'))
      }
      callback()
    }

    var StockValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('库存不能为空'));
      }
      // 正整数正则表达式
      const regex = /^[1-9]\d*$/;

      if (!regex.test(value)) {
        return callback(new Error('请输入正整数'));
      }

      callback();
    }

    var shortNameValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('库存不能为空'));
      }

      // 校验字符串长度最多为4个字
      const maxLength = 4;
      if (value.length > maxLength) {
        return callback(new Error(`最多输入 ${maxLength} 个字`));
      }

      callback();
    }

    return {
      deliveryShow: true,
      showFirst: true,
      showNext: false,
      imgViewerVisible: false,
      preimgList: [],
      formData: {
        categoryFirstCode: '',
        categoryFirstName: '',
        categorySecondCode: '',
        categorySecondName: '',
        detail: '',
        // supplierCode: '00000000',
        // supplierName: '平台自营',
        productName: '',
        sellPoint: [],
        label: [],
        listImg: '',
        bannerImg: '',
        bigImg: '',
        reportImg: '',
        purchaseLimit: null,
        initialSalesVolume: null,

        // 商品规格数据
        productSkuList: [
          {
            skuImg: '',
            skuName: '',
            neWeightt: '',
            stock: '',
            sellPrice: '',
            unit: ''
          }
        ],

        isTeamDelivery: 0,
        isExpressDelivery: 0,
        isVipDelivery: 0,
        isSelfPickup: 0,

        productStatus: 1,
        chackStatus: 1
      },
      categoryName: '',
      isTeamDelivery: false,
      isExpressDelivery: true,
      isVipDelivery: false,
      isSelfPickup: false,
      type1: '0',
      bannerList: [],
      bigImgList: [],
      // 商品分类数据
      classifyDialog: false,
      classifySearch: {
        condition: {
          categoryName: '',
          level: '1',
          parentName: ''
        },
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 10
      },
      classifyData: {
        count: 0,
        classifyList: []
      },
      // 供应商数据
      supplierDialog: false,
      supplierSearch: {
        condition: {
          supplierName: '',
          name: '',
          linkPhone: ''
        },
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 10
      },
      supplierData: {
        count: 0,
        supplierList: []
      },
      clickPrevent: false,
      groupRight: {
        name: 'itxst2',
        pull: false, // 拖出
        put: false // 拖入
      },

      rules: {
        productName: [{required: true, message: '商品名称不能为空', trigger: 'blur'}],
        shortName: [{validator: shortNameValidator, trigger: 'blur'}],
        skuName: [{required: true, message: '规格不能为空', trigger: 'blur'}],
        originalPrice: [
          {validator: PriceValidator, trigger: 'blur'}
        ],
        sellPrice: [
          {validator: PriceValidator, trigger: 'blur'}
        ],
        stock: [
          {validator: StockValidator, trigger: 'blur'}
        ],
        neWeight: [{required: true, message: '净重不能为空', trigger: 'blur'}]
      },
      fileList:[],
      uploadLoading:false

    }
  },
  computed: {
    showsp() {
      return (index) => {
        return this.formData.sellPoint[index]
      }
    },
    showLabel() {
      return (index) => {
        return this.formData.label[index]
      }
    }
  },
  async created() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.formData.creator = userInfo.userInfo.nickName
    this.productCode = this.$route.query.productCode
    if (this.productCode) {
      this.getProductInfo(this.productCode)
    }
    await this.getAllClassify()
    await this.getAllSupplier()
  },
  methods: {

    addRedStar(h, {column}) {
      return [
        h('span', {style: 'color: red'}, '*'),
        h('span', ' ' + column.label)
      ]
    },

    // 卖点
    addsellpoint() {
      if (this.formData.sellPoint.length >= 3) {
        this.$message.warning('最多添加3个卖点')
        return
      }
      this.formData.sellPoint.push('')
    },

    delsellpoint(index) {
      this.formData.sellPoint.splice(index, 1)
    },
    updateSp(e, index) {
      this.$set(this.formData.sellPoint, index, e)
    },
    // 标签
    addLabel() {
      console.log(this.formData.label)
      if (this.formData.label.length >= 3) {
        this.$message.warning('最多添加3个标签')
        return
      }
      this.formData.label.push('')
    },
    // 删除标签
    dellabel(index) {
      this.formData.label.splice(index, 1)
    },
    updateLabel(e, index) {
      this.$set(this.formData.label, index, e)
    },
    // 富文本内容
    contentChange(content) {
      this.formData.detail = content
    },
    handleCurrentChangeClassify(val) {
      this.classifySearch.currPage = val
      this.getAllClassify()
    },
    handleCurrentChangeSupplier(val) {
      this.supplierSearch.currPage = val
      this.getAllSupplier()
    },
    async getProductInfo(val) {
      let _this = this
      await this.$http
        .post('/product/queryDetail', {
          productCode: val
        })
        .then(function (res) {
          if (res.data.code == 200) {
            _this.formData = res.data.data
            _this.formData.sellPoint = res.data.data.sellPoint ? res.data.data.sellPoint.split(',') : []
            _this.formData.label = res.data.data.label ? res.data.data.label.split(',') : []
            _this.isTeamDelivery =
              _this.formData.isTeamDelivery == 1
            _this.isExpressDelivery =
              _this.formData.isExpressDelivery == 1
            _this.isVipDelivery =
              _this.formData.isVipDelivery == 1
            _this.isSelfPickup =
              _this.formData.isSelfPickup == 1
            _this.bannerList = splitByComma(_this.formData.bannerImg).map(
              (f) => {
                return {url: f}
              }
            )
            _this.bigImgList = splitByComma(_this.formData.bigImg).map((f) => {
              return {url: f}
            })
            if (res.data.data.supplierCode != '00000000') {
              _this.deliveryShow = false
            }
            console.log('32432', _this.bannerList)
          } else {
            _this.$message({
              message: res.data.message,
              type: 'fail'
            })
          }
        })
    },
    goBack() {
      this.$router.back()
    },
    handleInput(value, index, type) {
      if (isNaN(value) || value < 0) {
        if (type == 1) {
          this.formData.productSkuList[index].netWeight = ''
        } else if (type == 2) {
          this.formData.productSkuList[index].stock = ''
        } else if (type == 4) {
          this.formData.productSkuList[index].volume = ''
        } else if (type == 5) {
          this.formData.productSkuList[index].size = ''
        } else if (type == 6) {
          this.formData.productSkuList[index].supplyPrice = ''
        } else if (type == 7) {
          this.formData.productSkuList[index].originalPrice = ''
        } else if (type == 8) {
          this.formData.productSkuList[index].sellPrice = ''
        }
        this.$message({
          message: '请输入有效数字！',
          type: 'fail'
        })
      }
    },
    handleOriginalPriceInput(value) {
      if (isNaN(value) || value < 0) {
        this.formData.originalPrice = ''
        this.$message({
          message: '请输入有效数字！',
          type: 'fail'
        })
      }
    },
    nextStep() {
      this.showFirst = false
      this.showNext = true
    },
    lastStep() {
      this.showFirst = true
      this.showNext = false
    },
    handBannerSuccess(file) {
      this.uploadLoading = false
      this.bannerList.push({
        url: file.data.url
      })
      // this.formData.bannerImg = this.bannerList.join(',');
      this.formData.bannerImg = this.bannerList
        ? this.bannerList.map((item) => item.url).join(',')
        : ''
    },
    handleBannerRemove(oitem, index) {
      this.bannerList.splice(index, 1)
      this.formData.bannerImg = this.bannerList
        ? this.bannerList.map((item) => item.url).join(',')
        : ''
    },
    // handleBannerRemove(file, fileList) {
    //   let picArr = [];
    //   if (fileList?.length) {
    //     fileList.forEach((item) => {
    //       picArr.push({
    //         url: item.url,
    //       });
    //     });
    //     this.bannerList = picArr;
    //   } else {
    //     this.bannerList = [];
    //   }
    //   this.formData.bannerImg = this.bannerList
    //     ? this.bannerList.map((item) => item.url).join(",")
    //     : "";
    // },


    async handBigImgSuccess(response, file, fileList) {
      this.uploadLoading = false

      this.fileList = fileList
      console.log(this.fileList, 'success')
      const urls = await Promise.all(
        fileList.map(async (item) => {
          if (item.response) {
            return item.response.data.url
          }
        })
      )

      // 过滤掉可能的空值
      this.bigImgList = urls.filter(Boolean).map((url) => ({ url }))

      // 更新 formData.bigImg
      this.formData.bigImg = this.bigImgList.length > 0
        ? this.bigImgList.map((item) => item.url).join(',')
        : ''

      console.log('Updated bigImgList:', this.bigImgList)
      console.log('Updated formData.bigImg:', this.formData.bigImg)
    },
    onUpdate(e) {
      // console.log('??',e,this.bigImgList,this.formData.bigImg)
      this.formData.bigImg = this.bigImgList
        ? this.bigImgList.map((item) => item.url).join(',')
        : ''
    },
    handleBigImgRemove(oitem, index) {
      this.bigImgList.splice(index, 1)
      this.fileList.splice(index, 1)
      console.log(this.fileList, 'del')
      this.formData.bigImg = this.bigImgList
        ? this.bigImgList.map((item) => item.url).join(',')
        : ''
    },
    // handleBigImgRemove(file, fileList) {
    //   let picArr = [];
    //   if (fileList?.length) {
    //     fileList.forEach((item) => {
    //       picArr.push({
    //         url: item.url,
    //       });
    //     });
    //     this.bigImgList = picArr;
    //   } else {
    //     this.bigImgList = [];
    //   }
    //   this.formData.bigImg = this.bigImgList
    //     ? this.bigImgList.map((item) => item.url).join(",")
    //     : "";
    // },
    handleUploadListImgRemove(file, fileList) {
      this.formData.listImg = ''
    },
    handleUploadReportImgRemove(file, fileList) {
      this.formData.reportImg = ''
    },
    handleRemove(file, fileList, iscustom, attr) {
      this.formData[attr] = ''
    },
    handlePictureCardPreview(file, iscustom) {
      this.$nextTick(() => {
        this.preimgList = [file]
        this.imgViewerVisible = true
      })
    },
    closeImgViewer() {
      this.imgViewerVisible = false
    },
    // 图片上传成功处理
    handleUploadListImgSuccess(res, file) {
      this.uploadLoading = false
      this.formData.listImg = file.response.data.url
      //   this.$forceUpdate(); // 触发强制刷新
    },
    handleUploadReportImgSuccess(res, file) {
      this.uploadLoading = false
      this.formData.reportImg = file.response.data.url
      //   this.$forceUpdate(); // 触发强制刷新
    },

    // 规格图片上传成功处理
    handleUploadSkuImg(file, index) {
      this.uploadLoading = false
      this.formData.productSkuList[index].skuImg = file.response.data.url
      //   this.$forceUpdate(); // 触发强制刷新
    },
    // 图片校验
    beforeAvatarUpload(file) {
      const ImageType =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg'

      if (!ImageType) {
        this.$message.error('上传图片只能是 JPG 、PNG 、JPEG 格式!')
      }
      return ImageType
    },
    // 商品分类操作
    async showClassifyDialog(level) {
      this.classifySearch.condition.level = level
      if (level == 2) {
        this.classifySearch.condition.parentCode =
          this.formData.categoryFirstCode
      }
      await this.searchClassify()
      this.classifySearch.condition.parentCode = ''
      this.classifyDialog = true
    },
    async searchClassify() {
      this.classifySearch.currPage = 1
      await this.getAllClassify()
    },
    async getAllClassify() {
      // 获取所有商品分类
      let _this = this
      await this.$http
        .post('/productCategory/list', {
          ..._this.classifySearch
        })
        .then(function (res) {
          let {count, currPage, data, pageCount, pageSize} = res.data.data
          _this.classifyData.classifyList = data
          _this.classifyData.count = count
        })
    },
    restClassify() {
      this.classifySearch.condition.categoryName = ''
      this.classifySearch.condition.level = ''
      this.classifySearch.currPage = 1
      this.classifySearch.pageCount = 0
      this.classifySearch.pageSize = 10
      this.getAllClassify()
    },
    selectClassify(row) {
      // 分类弹窗选择某项
      if (row.level === 1) {
        this.formData.categoryFirstCode = row.categoryCode
        this.formData.categoryFirstName = row.categoryName
        this.formData.categorySecondCode = ''
        this.formData.categorySecondName = ''
      } else {
        this.formData.categoryFirstCode = row.parentCode
        this.formData.categoryFirstName = row.parentName
        this.formData.categorySecondCode = row.categoryCode
        this.formData.categorySecondName = row.categoryName
      }
      this.categoryName = row.categoryName
      this.classifyDialog = false
    },

    // 选择供应商弹窗操作
    showSupplierDialog() {
      this.supplierDialog = true
    },
    searchSupplier() {
      this.supplierSearch.currPage = 1
      this.getAllSupplier()
    },
    getAllSupplier() {
      // 获取所有供应商
      let _this = this
      this.$http
        .post('/memberSupplier/list', {
          ..._this.supplierSearch
        })
        .then(function (res) {
          let {count, currPage, data, pageCount, pageSize} = res.data.data
          _this.supplierData.supplierList = data
          _this.supplierData.count = count
        })
    },
    restSupplier() {
      this.supplierSearch.condition.supplierName = ''
      this.supplierSearch.condition.name = ''
      this.supplierSearch.condition.linkPhone = ''
      this.supplierSearch.currPage = 1
      this.supplierSearch.pageCount = 0
      this.supplierSearch.pageSize = 10
      this.getAllSupplier()
    },
    selectSupplier(row) {
      // 供应商弹窗选择某项
      this.formData.supplierCode = row.supplierCode
      this.formData.supplierName = row.supplierName
      // 如果是非平台，不展示物流配置
      if (row.supplierCode != '00000000') {
        this.deliveryShow = false
        this.isExpressDelivery = 1
      }
      this.supplierDialog = false
    },
    resetSupplier() {
      this.formData.supplierName = '平台自营'
      this.formData.supplierCode = '00000000'
    },
    // 添加规格操作
    addItem() {
      this.formData.productSkuList.push({
        skuImg: '',
        skuName: '',
        netWeight: '',
        stock: '',
        sellPrice: '',
        unit: ''
      })
    },
    removeItem(index) {
      this.formData.productSkuList.splice(index, 1)
    },
    publish() {

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log(valid, 1106)
          // alert('submit!');

          if (this.clickPrevent) {
            return
          }

          if (this.formData.sellPoint.some(item => item == '')) {
            this.$nextTick(() => {
              this.$refs.sellPointaid.focus()
            })
            return this.$message.warning('添加的卖点描述不能为空！')
          }
          if (this.formData.label.some(item => item == '')) {
            this.$nextTick(() => {
              this.$refs.labelaid.focus()
            })
            return this.$message.warning('添加的标签不能为空！')
          }

          if (this.formData.productSkuList.some(item => !item.skuImg)) {
            return this.$message.warning('请完善规格图片！');
          }

          if (!this.isTeamDelivery && !this.isExpressDelivery && !this.isVipDelivery && !this.isSelfPickup) {
            return this.$message.warning('至少选择一种配送方式！');
          }

          console.log(this.formData)
          let _this = this
          let formData = {
            ...this.formData,
            sellPoint: this.formData.sellPoint.join(','),
            label: this.formData.label.join(','),
            isTeamDelivery: this.isTeamDelivery ? 1 : 0,
            isExpressDelivery: this.isExpressDelivery ? 1 : 0,
            isVipDelivery: this.isVipDelivery ? 1 : 0,
            isSelfPickup: this.isSelfPickup ? 1 : 0,
            merchantName:localStorage.getItem('merchantName')
          }
          this.clickPrevent = true
          this.$http
            .post('/product/save', {
              ...formData
            })
            .then(function (res) {
              console.log(res)

              let {code} = res.data
              if (code === 200) {
                _this.$message({
                  message: '保存成功!',
                  type: 'success'
                })
                // _this.goBack();
                _this.$router.back()
              } else {
                _this.$message({
                  message: res.data.message,
                  type: 'fail'
                })
              }
              _this.clickPrevent = false
            })
            .catch((err) => {
              _this.clickPrevent = false
            })

        } else {
          // console.log('error submit!!');
          this.$message.error("请补全商品信息")
          return false;
        }
      });


    }
  }
}
</script>

<style lang="less" scoped>
.children-box {
  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
  }

  .procedure {
    width: 90%;

    .step {
      background-color: #eff8fe;
      display: flex;
      align-items: center;
      padding-left: 30px;
    }

    .firstStep {
      margin-top: 10px;
      padding-left: 30px;
    }

    .twoStep {
      margin-top: 10px;
      padding-left: 30px;
    }
  }

  .title {
    background-color: #f1f1f1;
  }
}

.select-box {
  .item-col {
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    .label {
      margin-right: 10px;
    }

    div {
      flex: 1;
    }
  }
}

.item-num {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.active-color {
  background-color: #1e98d7;
  color: #fff;
}

.size {
  display: flex;
  align-items: center;
  justify-content: center;
}

.unactive-color {
  border: 0.5px solid #adadad;
  border-color: #adadad;

}

.item-text {
  margin: 0 10px;
}

.line {
  width: 80px;
  height: 0.5px;
  border-top: 1px solid #adadad;
  margin: 0 10px;
}

.last-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  margin-top: 50px;
  margin-left: 50px;
  border: 1px solid #adadad;
  border-radius: 10px;
  color: #333;
  cursor: pointer;
}

.next-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  margin-top: 50px;
  margin-left: 70px;
  background-color: #1e98d7;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
}

.btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;

  div {
    transform: translateX(-60%);
  }
}

/deep/ .el-form {
  margin-top: 50px;

  .el-input {
    width: 300px;
  }

  .el-input-number {
    .el-input__inner {
      width: 100px;
    }
  }
}

.avatar {
  width: 146px;
  height: 146px;
  display: block;
}

.avatarSmall {
  width: 60px;
  height: 60px;
  display: block;
}

.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  align-items: center;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 146px;
  text-align: center;
}

.small-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.spec-row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spec-item {
  margin-right: 30px;
  flex: 1;
}

.spec-item input {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
}

button {
  padding: 5px 10px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

.label_list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .label_item {
    margin-right: 14px;
    position: relative;

    .label_item_opt {
      position: absolute;
      top: -16px;
      right: -10px;
      font-size: 18px;
      padding: 2px;
      cursor: pointer;
      opacity: 0.4;

      &:hover {
        color: red;
      }
    }

    &:hover,
    &:focus {
      .label_item_opt {
        opacity: 1;
      }
    }
  }

  .label_btn {
    /deep/ span {
      display: flex;
      align-items: center;
    }

    padding: 0 12px;
    font-size: 14px;
  }
}

::v-deep {
  .el-form .el-input {
    width: 100px;
  }
}

.imglist_c {
  display: flex;
  flex-wrap: wrap;
  width: auto;
}

.imglist_c .img-option {
  .img-option_item {
    width: 146px;
    height: 146px;
    flex-shrink: 0;
    margin-left: 5px;
    position: relative;
  }
}

.el-upload-list__item-actions {
  span {
    padding: 0 4px;
  }

  i {
    line-height: 146px;
    color: #fff;
  }
}

.cardDrag-list-wrap {
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .comp-item {
    cursor: grab;
  }

  .active_comp {
    border: 1px solid #155bd4;
  }
}


.tableSku ::v-deep .el-form-item__error {
  position: absolute;
  top: 100%;
  left: 25% !important;

}
</style>
